import React from 'react';
import { AppLocaleProvider } from 'sd-ui-components';
import moment from 'moment-timezone';

const { injectIntl } = AppLocaleProvider;

const FormattedDate = props => {
  if (!props.value) {
    return <div />;
  }
  const date = moment(props.value, 'YYYY-MM-DDTHH:mm:ss').format('LLL');
  const computedTimeZone = moment.tz(props.value, props.timeZone).format('z');
  return (
    <div>
      <span>
        {' '}
        {props.intl.formatDate(
          date,
          Object.assign({}, props, {
            timeZone: undefined,
            timeZoneName: undefined
          })
        )}{' '}
      </span>
      <span> {`${props.timeZoneName ? computedTimeZone : ''}`}</span>
    </div>
  );
};
export default injectIntl(FormattedDate);



// WEBPACK FOOTER //
// ./src/containers/Common/FormattedDate.jsx